import React from "react";
import { Box, Typography } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import StatusPill from "./StatusPill";
// Fix: Import as named exports (with curly brackets)
import { Avatar, cTimeFormat } from "./VoiceCampaignsList";

const CampaignRow = ({ item, onClick, onRepush }) => {
  const ts = item.createdAt ?? item.launchedAt;
  const agents = item.agentRows?.patchList ?? [];

  const handleRepush = (e) => {
    e.stopPropagation(); // Prevents opening the modal
    if (onRepush) {
      onRepush(item);
    }
  };

  return (
    <Box
      onClick={() => onClick(item)}
      sx={{
        display: "grid",
        gridTemplateColumns: "40px 1fr auto auto",
        alignItems: "center",
        gap: 2,
        px: 2.5,
        py: 1.75,
        borderBottom: "1px solid rgba(0,0,0,.06)",
        cursor: "pointer",
        transition: "background .15s",
        "&:hover": { background: "rgba(0,0,0,.03)" },
        "&:last-child": { borderBottom: "none" },
      }}
    >
      <Avatar name={item.customerId} />

      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 13.5,
            fontWeight: 600,
            color: "#111",
            fontFamily: "'IBM Plex Mono',monospace",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.campaignName}
        </Typography>
        <Typography
          sx={{
            fontSize: 11.5,
            color: "#666",
            mt: 0.2,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontFamily: "'IBM Plex Mono',monospace",
          }}
        >
          {item.customerId} · #{item.campaignId}
        </Typography>
      </Box>

      <Box
        sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#666" }}
      >
        <GroupIcon sx={{ fontSize: 14 }} />
        <Typography
          sx={{
            fontSize: 12,
            color: "#555",
            fontFamily: "'IBM Plex Mono',monospace",
          }}
        >
          {agents.length}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: 0.5,
        }}
      >
        <StatusPill
          status={item.status ?? "launched"}
          onRepush={handleRepush}
        />
        <Typography
          sx={{
            fontSize: 10,
            color: "#777",
            fontFamily: "'IBM Plex Mono',monospace",
          }}
        >
          {cTimeFormat(ts)}
        </Typography>
      </Box>
    </Box>
  );
};

export default CampaignRow;
